import styled from "@emotion/styled";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

export const Value = styled.span<{ hasSpaces?: boolean }>`
  color: var(${DesignToken.ContentBasicPrimary});
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  ${({ hasSpaces }): string => (hasSpaces ? "word-break: break-word" : "")};
  overflow: hidden;
`;

export const EmptyValue = styled(Value)`
  color: var(${DesignToken.ContentBasicDisabled});
`;

export const StyledLabelValue = styled(Text)`
  color: var(${DesignToken.ContentBasicSecondary});
`;

export const Container = styled.div`
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  min-height: 24px;
  padding: var(${SpacingToken.Spacing1}) 0;
  display: flex;
  align-items: center;
`;

export const StyledLabel = styled.span<{ inline: boolean }>`
  ${({ inline }): string => (!inline ? "display: block" : "")};
`;

export const StyledImage = styled.img`
  border-radius: 4px;
  width: 24px;
  height: 24px;
  margin-right: 4px;
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
`;
